// extracted by mini-css-extract-plugin
export default {"productsGroup":"styles_productsGroup__uiAkr","productsList":"styles_productsList__vkc2z","container":"styles_container__Kqr4Z","groupTitle":"styles_groupTitle__0y9h0"};